import {
  BankOutlined,
  CloseOutlined,
  DeleteOutlined,
  EditOutlined,
  FileTextOutlined,
  PlusOutlined,
  TeamOutlined,
  UploadOutlined,
  UserOutlined,
} from '@ant-design/icons'
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  Row,
  Space,
  Tag,
  Tooltip,
  Upload,
  message,
} from 'antd'
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import React, { useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { blue, redPrimary, yellowPrimary } from '../../../color'
import { AvatarHasName } from '../../../components/Common/Avatar'
import RichEditor from '../../../components/RichEditor/RichEditor'
import SelectGroupPopup from '../../../components/SelectGroupPopup'
import SelectPeoplePopup from '../../../components/SelectPeoplePopup'
import { ASSIGNEE_TYPE } from '../../../constants'
import { SelectList } from '../InternalDocumentOutgoingDocCreatePage/InternalDocumentOutgoingDocCreatePageStyled'
import {
  FileAction,
  FileItem,
  SignDocumentList,
} from '../InternalDocumentSignDocDetailPage/InternalDocumentSignDocDetailPageStyled'

const { Dragger } = Upload
const { RangePicker } = DatePicker
const FeedbackBoardUpdate = ({
  handleCancel,
  isVisible,
  feedbackDetailData,
  selectPeopleStore,
  fileStore,
  FeedbackProcedureStore,
  loadingAnimationStore,
  departmentStore,
  userGroupStore,
  authenticationStore,
  fetchFeedback,
  setIsVisible,
  assignees,
  finalUserList,
}) => {
  const {
    selectUserData,
    selectDepartmentData,
    selectGroupData,
    isVisibleSelectGroupPopup,
    setIsVisibleSelectGroupPopup,
    isVisibleSelectUserDepartmentPopup,
    setIsVisibleSelectUserDepartmentPopup,
    handleOpenSelectUserDepartmentPopup,
    handleCancelSelectUserDepartment,
    handleOpenSelectGroupPopup,
    handleCancelSelectGroup,
    originDepartmentWithUserList,
    handleRemoveSelect,
    clearSelected,
    companyCode,
    setSelectUserData,
    setSelectDepartmentData,
    clearSelectUserData,
    originGroupList,
  } = selectPeopleStore
  const { getDepartmentList, departmentListHDQT } = departmentStore
  const { allDataGroupList, groupActive } = userGroupStore
  const [form] = Form.useForm()
  const OPINION_REF = useRef()
  const BASIS_REF = useRef()
  const ATTACHED_REF = useRef()
  const OTHER_REF = useRef()
  const history = useHistory()
  const [fileList, setFileList] = useState([])
  const [editorContent, setEditorContent] = useState({
    opinionContent: '',
    basis: '',
    attachedDocs: '',
    otherContent: '',
  })
  const [opinionContent, setOpinionContent] = useState(null)
  const [basis, setBasis] = useState(null)
  const [attachedDocs, setAttachedDocs] = useState(null)
  const [otherContent, setOtherContent] = useState(null)
  const [handlerList, setHandlerList] = useState([])
  const [followerList, setFollowerList] = useState([])
  const [isSubmitting, setIsSubmitting] = useState(false)
  const otherContentRefs = useRef([])
  const [otherContentList, setOtherContentList] = useState([
    { id: 1, content: null },
  ])
  useEffect(() => {
    ;(async () => {
      await clearSelectUserData()
      await setFollowerList([])
      await clearSelected()
      await getDepartmentList()
    })()
  }, [])
  assignees?.forEach(el => {
    const user =
      finalUserList &&
      finalUserList?.find(user => user.username === el.assignee_code)
    if (user) {
      el.name_uppercase = user.name_uppercase
    }
  })

  const userList = assignees
    ? assignees.filter(
        el =>
          el.assignee_type === ASSIGNEE_TYPE.USER &&
          el.permission !== ASSIGNEE_TYPE.CREATE
      )
    : []

  const departmentList = assignees
    ? assignees.filter(el => el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT)
    : []

  const groupList = assignees
    ? assignees.filter(el => el.assignee_type === ASSIGNEE_TYPE.GROUP)
    : []

  useEffect(() => {
    const combinedHandlerList = [
      ...selectUserData[ASSIGNEE_TYPE.HANDLER],
      ...selectDepartmentData[ASSIGNEE_TYPE.HANDLER],
      ...selectGroupData[ASSIGNEE_TYPE.HANDLER],
    ]

    const uniqueHandlerList = combinedHandlerList.filter(
      (item, index, self) =>
        index ===
        self.findIndex(
          t => t.id === item.id && t.assignee_type === item.assignee_type
        )
    )

    setHandlerList(uniqueHandlerList)

    const combinedFollowerList = [
      ...selectUserData[ASSIGNEE_TYPE.FOLLOWER],
      ...selectDepartmentData[ASSIGNEE_TYPE.FOLLOWER],
      ...selectGroupData[ASSIGNEE_TYPE.FOLLOWER],
    ]

    const uniqueFollowerList = combinedFollowerList.filter(
      (item, index, self) =>
        index ===
        self.findIndex(
          t => t.id === item.id && t.assignee_type === item.assignee_type
        )
    )

    setFollowerList(uniqueFollowerList)
  }, [selectUserData, selectDepartmentData, selectGroupData])

  followerList.forEach(assignee => {
    // Kiểm tra điều kiện: assignee_type === "USER"
    if (assignee.assignee_type === 'USER') {
      // Lặp qua các nhóm để tìm user với id trùng khớp
      allDataGroupList.forEach(group => {
        group.groupUsers.forEach(user => {
          if (String(user.id) === assignee.id) {
            assignee.full_name = user.user.name_lowercase.toUpperCase()
          }
        })
      })
    }
  })

  useEffect(() => {
    ;(async () => {
      if (authenticationStore.currentUser) {
        try {
          loadingAnimationStore.showSpinner(true)
          const responseGroupList = await userGroupStore.getAllGroupList()
        } catch (err) {
          // console.log(err)
          message.error('Đã có lỗi xảy ra!')
        } finally {
          loadingAnimationStore.showSpinner(false)
        }
      }
    })()
  }, [authenticationStore.currentUser])

  // Sửa useEffect load initial assignees — enrich tên GRP và DPT trước khi set
  useEffect(() => {
    if (!isVisible) return
    if (!originDepartmentWithUserList?.length) return

    // Build dept name map từ originDepartmentWithUserList
    const deptNameMap = new Map()
    originDepartmentWithUserList?.forEach(dept => {
      deptNameMap.set(dept.code, dept.name)
      dept.users?.forEach(u =>
        deptNameMap.set(u.user_name ?? u.user_code, u.name_uppercase)
      )
    })

    const enrichAssignee = el => {
      if (el.assignee_type === 'DPT' || el.assignee_type === 'USER') {
        return {
          ...el,
          name_uppercase:
            deptNameMap.get(el.assignee_code) || el.name_uppercase,
        }
      }
      if (el.assignee_type === 'GRP') {
        const grp = allDataGroupList?.find(
          g => g.id.toString() === el.assignee_code
        )
        return {
          ...el,
          name_uppercase: grp?.name?.toUpperCase() || el.name_uppercase,
        }
      }
      return el
    }

    const enrichedUsers = userList.map(enrichAssignee)
    const enrichedDepts = departmentList.map(enrichAssignee)
    const enrichedGroups = groupList.map(enrichAssignee)

    if (
      selectUserData[ASSIGNEE_TYPE.HANDLER].length === 0 &&
      selectUserData[ASSIGNEE_TYPE.FOLLOWER].length === 0
    ) {
      selectPeopleStore.setSelectUserData(
        selectPeopleStore.convertSelectDataObj(enrichedUsers)
      )
    }

    if (
      selectDepartmentData[ASSIGNEE_TYPE.HANDLER].length === 0 &&
      selectDepartmentData[ASSIGNEE_TYPE.FOLLOWER].length === 0
    ) {
      selectPeopleStore.setSelectDepartmentData(
        selectPeopleStore.convertSelectDataObj(enrichedDepts)
      )
    }

    if (
      selectGroupData[ASSIGNEE_TYPE.HANDLER].length === 0 &&
      selectGroupData[ASSIGNEE_TYPE.FOLLOWER].length === 0
    ) {
      selectPeopleStore.setSelectGroupData(
        selectPeopleStore.convertSelectDataObj(enrichedGroups)
      )
    }
  }, [originDepartmentWithUserList, allDataGroupList])

  useEffect(() => {
    if (isVisible && feedbackDetailData) {
      form.setFieldsValue({
        title: feedbackDetailData.title,
        documentNumber: feedbackDetailData.documentNumber,
        startDate: moment(feedbackDetailData.startDate, [
          'YYYY-MM-DD',
          'DD-MM-YYYY',
        ]),
        endDate: moment(feedbackDetailData.endDate, [
          'YYYY-MM-DD',
          'DD-MM-YYYY',
        ]),
        basis: feedbackDetailData.legalBasis,
        // opinionContent: feedbackDetailData.content,
        // attachedDocs: feedbackDetailData.attachedDocuments,
        // otherContent: feedbackDetailData.otherContent,
      })

      // setEditorContent({
      //   opinionContent: feedbackDetailData.content,
      //   basis: feedbackDetailData.legalBasis,
      //   attachedDocs: feedbackDetailData.attachedDocuments,
      //   otherContent: feedbackDetailData.otherContent,
      // })
      const comments = (feedbackDetailData.feedbackComments || []).map(comment => ({
        id: comment.id,
        content: comment.content || '', // Ensure empty content is handled
      }))

      // Set otherContentList with comments or ensure at least one editor
      setOtherContentList(
        comments.length > 0 ? comments : [{ id: Date.now(), content: '' }]
      )

      // Set fileList and assignees
      setFileList(
        (feedbackDetailData.fileIdAttachment || []).map(item => ({
          fileId: item.fileId || item.file_id,
          name: item.fileName || item.file_name,
          fileName: item.fileName || item.file_name,
          uid: item.uid || item.fileId || item.file_id,
        }))
      )
    }
  }, [isVisible, feedbackDetailData])

  const onFinish = async values => {
    const { startDate, endDate } = values
    setIsSubmitting(true)
    const otherContentData = otherContentRefs.current.map(ref => ({
      id: ref.id,
      content: ref.ref ? ref.ref.editor.getData() : '',
    }))
    try {
      const newUploadFiles = (fileList || []).filter(file => file.originFileObj)
      const batchUploadArr = newUploadFiles.map(file => {
        const formData = new FormData()
        formData.append('file', file.originFileObj)
        return fileStore.uploadFile(formData)
      })

      const handlerData = handlerList.map(el => ({
        assignee_code: el.id,
        assignee_type: el.assignee_type,
        permission: el.permission,
      }))

      const managerData = followerList.map(el => ({
        assignee_code: el.id,
        assignee_type: el.assignee_type,
        permission: el.permission,
      }))
      if (endDate.isBefore(startDate)) {
        return message.info('Ngày kết thúc phải lớn hơn ngày bắt đầu!')
      }

      if (managerData.length === 0) {
        return message.info('Bạn chưa chọn Người theo dõi!')
      }
      if (handlerData.length === 0) {
        return message.info('Bạn chưa chọn người xử lý !')
      }

      const uploadResponses = await Promise.all(batchUploadArr)
      const uploadedAttachments = uploadResponses
        .map((response, index) => ({
          fileId: response?.data?.file_id || response?.data?.fileId,
          fileName:
            response?.data?.file_name ||
            response?.data?.fileName ||
            newUploadFiles[index]?.name,
        }))
        .filter(file => file.fileId)

      const existingAttachments = (fileList || [])
        .filter(file => file.fileId && !file.originFileObj)
        .map(file => ({
          fileId: file.fileId,
          fileName: file.name || file.fileName,
        }))

      const fileIdAttachment = [...existingAttachments, ...uploadedAttachments]
        .filter(
          (file, index, list) =>
            list.findIndex(item => item.fileId === file.fileId) === index
        )

      const submitData = {
        title: values.title,
        startDate: startDate.format('YYYY-MM-DD'),
        endDate: endDate.format('YYYY-MM-DD'),
        legalBasis: BASIS_REF?.current?.editor.getData(),
        attachedDocuments: ATTACHED_REF?.current?.editor.getData(),
        otherContent: OTHER_REF?.current?.editor.getData(),
        status: 'DISAGREED',
        documentNumber: values.documentNumber,
        fileIdAttachment,
        feedbackComments: otherContentData
          .filter(item => item.content && item.content !== '')
          .map(item => {
            const comment = { content: item.content }
            if (item.id && Number(item.id) < 1e12) {
              comment.id = item.id
            }
            return comment
          }),
        assignees: [
          ...new Set([...handlerData, ...managerData].map(JSON.stringify)),
        ].map(JSON.parse),
      }
      // console.log(submitData)
      const response = await FeedbackProcedureStore.updateFeedbackProcedure(
        submitData,
        feedbackDetailData.id
      )

      if (response.status === 200) {
        setIsVisible(false)
        message.success('Cập nhật thành công!')
        form.resetFields()
        setOpinionContent(null)
        setBasis(null)
        setAttachedDocs(null)
        setOtherContent(null)
        setFileList([])
        setFollowerList([])
        setHandlerList([])
        selectPeopleStore.clearSelectUserData()
        selectPeopleStore.clearSelectDepartmentData()
        selectPeopleStore.clearSelectedHandlerAndFollower()
        fetchFeedback()
      } else {
        console.error('Error in form submission:', response)
      }
    } catch (error) {
      console.error('Error in form submission:', error)
      message.error(
        error?.response?.data?.message ||
          error?.vi ||
          'Cập nhật thất bại, vui lòng thử lại!'
      )
    } finally {
      setIsSubmitting(false)
    }
  }
  const handleEditorChange = (field, content) => {
    setEditorContent(prevState => ({
      ...prevState,
      [field]: content,
    }))
  }

  const handleChangeFile = info => {
    if (info.fileList.length === 0) {
      form.setFieldsValue({
        file: undefined,
      })
      setFileList([])
      return
    }
    const mergedFileList = info.fileList
      .filter(
        (elem, index, list) =>
          list.findIndex(
            file => file.uid === elem.uid || file.name === elem.name
          ) === index
      )
      .map(file => {
        const prev = fileList.find(
          item => item.uid === file.uid || item.name === file.name
        )
        return {
          ...file,
          fileId: file.fileId || file.file_id || prev?.fileId || prev?.file_id,
          fileName: file.name || file.fileName || prev?.fileName || prev?.name,
          name: file.name || file.fileName || prev?.name,
        }
      })
    setFileList(mergedFileList)
  }

  const handleOtherContentChange = (id, content) => {
    setOtherContentList(prevList =>
      prevList.map(item => (item.id === id ? { ...item, content } : item))
    )
  }

  const handleAddOtherContent = () => {
    const newContent = { id: Date.now(), content: '' }
    setOtherContentList(prevList => [...prevList, newContent])
  }

  const handleRemoveOtherContent = id => {
    setOtherContentList(prevList => {
      const updatedList = prevList.filter(item => item.id !== id)
      return updatedList
    })

    otherContentRefs.current = otherContentRefs.current.filter(
      ref => ref.id !== id
    )
  }
  followerList.forEach(item1 => {
    const matchedGroup = originGroupList.find(
      item2 => item2.id === parseInt(item1.id)
    )
    if (matchedGroup) {
      item1.full_name = matchedGroup.name
    }
  })
  return (
    <>
      <Modal
        title="Cập nhật quy trình lấy ý kiến"
        visible={isVisible} // This must match the prop passed from the parent
        onCancel={handleCancel}
        footer={null}
        width={800}
        maskClosable={false}>
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          style={{ maxWidth: '800px', margin: '0 auto' }}>
          <Form.Item
            label="Số hồ sơ"
            name="documentNumber"
            rules={[{ required: true, message: 'Vui lòng nhập số hồ sơ!' }]}>
            <Input placeholder="Nhập số hồ sơ" addonAfter="/PLYK-HĐQT" />
          </Form.Item>
          <Form.Item
            label="Tiêu đề"
            name="title"
            rules={[{ required: true, message: 'Vui lòng nhập tiêu đề!' }]}>
            <Input placeholder="Nhập tiêu đề" />
          </Form.Item>
          {/* <Form.Item label="Nội dung lấy ý kiến" name="opinionContent">
            <RichEditor
              EDITOR_REF={OPINION_REF}
              editorContent={feedbackDetailData.content}
              height={200}
            />
          </Form.Item> */}
          <Form.Item label="Nội dung lấy ý kiến">
            {otherContentList.map((item, index) => (
              <div
                key={item.id}
                style={{ position: 'relative', marginBottom: '16px' }}>
                <RichEditor
                  EDITOR_REF={el => {
                    otherContentRefs.current[index] = { id: item.id, ref: el }
                  }}
                  editorContent={item.content}
                  height={100}
                  onChange={content =>
                    handleOtherContentChange(item.id, content)
                  }
                />
                {otherContentList.length > 1 && (
                  <Button
                    type="text"
                    icon={<DeleteOutlined style={{ color: 'red' }} />}
                    onClick={() => handleRemoveOtherContent(item.id)}
                    style={{ position: 'absolute', top: '0', right: '-27px' }}
                  />
                )}
              </div>
            ))}
            <Button
              type="dashed"
              icon={<PlusOutlined />}
              onClick={handleAddOtherContent}
              style={{ width: '100%', marginTop: '10px' }}>
              Thêm nội dung ý kiến khác
            </Button>
          </Form.Item>

          <Row gutter={[16, 16]}>
            <Col span={12}>
              <Form.Item
                label="Ngày bắt đầu"
                name="startDate"
                rules={[
                  { required: true, message: 'Vui lòng nhập ngày bắt đầu!' },
                ]}>
                <DatePicker format={'DD/MM/YYYY'} style={{ width: '100%' }} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Ngày kết thúc"
                name="endDate"
                rules={[
                  { required: true, message: 'Vui lòng nhập ngày kết thúc!' },
                ]}>
                <DatePicker format={'DD/MM/YYYY'} style={{ width: '100%' }} />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item label="Các căn cứ" name="basis">
            <RichEditor
              EDITOR_REF={BASIS_REF}
              editorContent={feedbackDetailData.legalBasis}
              height={100}
            />
          </Form.Item>

          <Form.Item label="Tài liệu kèm theo" name="attachedDocs">
            <RichEditor
              EDITOR_REF={ATTACHED_REF}
              editorContent={feedbackDetailData.attachedDocuments}
              height={50}
            />
          </Form.Item>

          <Form.Item label="Nội dung khác" name="otherContent">
            <RichEditor
              EDITOR_REF={OTHER_REF}
              editorContent={feedbackDetailData.otherContent}
              height={100}
            />
          </Form.Item>

          <Form.Item label={'Tài liệu kèm theo:'} name={'file'}>
            <Upload
              valuePropName={'fileList'}
              fileList={fileList}
              multiple={true}
              beforeUpload={() => false}
              onChange={handleChangeFile}
              showUploadList={false}>
              <Button icon={<UploadOutlined />}>Chọn tài liệu kèm theo</Button>
            </Upload>
            <SignDocumentList>
              {fileList.map((file, index) => (
                <FileItem key={file.uid}>
                  <span>
                    <FileTextOutlined style={{ marginRight: 5 }} />
                    {file.name}
                  </span>
                  <FileAction>
                    <Tooltip title={'Xóa'}>
                      <Button
                        type={'text'}
                        icon={<DeleteOutlined style={{ color: redPrimary }} />}
                        onClick={() =>
                          setFileList(
                            fileList.filter(el => el.uid !== file.uid)
                          )
                        }
                      />
                    </Tooltip>
                  </FileAction>
                </FileItem>
              ))}
            </SignDocumentList>
          </Form.Item>
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <span>
                <span
                  style={{
                    color: '#ff4d4f',
                    fontFamily: 'SimSun, sans-serif',
                    marginRight: '-4px',
                  }}>
                  *{' '}
                </span>
                <span style={{ marginRight: '10px' }}>Người xử lý</span>
              </span>
              <Space>
                <Tooltip title="Chọn người dùng" color={blue}>
                  <Button
                    icon={<UserOutlined style={{ color: blue }} />}
                    onClick={() =>
                      handleOpenSelectUserDepartmentPopup(ASSIGNEE_TYPE.HANDLER)
                    }
                  />
                </Tooltip>
                <Tooltip title="Chọn nhóm" color={'#ffc069'}>
                  <Button
                    icon={<TeamOutlined />}
                    style={{ color: yellowPrimary }}
                    onClick={() =>
                      handleOpenSelectGroupPopup(ASSIGNEE_TYPE.HANDLER)
                    }
                  />
                </Tooltip>
              </Space>
              <span style={{ height: '10px' }}></span>
              <SelectList>
                {handlerList.map(el => (
                  <Tag
                    className={'tag-selected'}
                    color={'blue'}
                    style={{ marginTop: '10px' }}
                    key={el.id}
                    closable
                    onClose={() => selectPeopleStore.handleRemoveSelect(el)}>
                    <AvatarHasName
                      imgId={el.image_id}
                      size={22}
                      name={el.full_name}
                      icon={
                        (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                          <BankOutlined />
                        )) ||
                        (el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                          <TeamOutlined />
                        ))
                      }
                    />
                  </Tag>
                ))}
              </SelectList>
            </Col>

            <Col span={12}>
              <span>
                <span
                  style={{
                    color: '#ff4d4f',
                    fontFamily: 'SimSun, sans-serif',
                    marginRight: '-4px',
                  }}>
                  *{' '}
                </span>
                <span style={{ marginRight: '10px' }}>Người theo dõi:</span>
              </span>
              <Space>
                <Tooltip title="Chọn người dùng" color={blue}>
                  <Button
                    icon={<UserOutlined style={{ color: blue }} />}
                    onClick={() =>
                      handleOpenSelectUserDepartmentPopup(
                        ASSIGNEE_TYPE.FOLLOWER
                      )
                    }
                  />
                </Tooltip>
                <Tooltip title="Chọn nhóm" color={'#ffc069'}>
                  <Button
                    icon={<TeamOutlined />}
                    style={{ color: yellowPrimary }}
                    onClick={() =>
                      handleOpenSelectGroupPopup(ASSIGNEE_TYPE.FOLLOWER)
                    }
                  />
                </Tooltip>
              </Space>
              <SelectList>
                {followerList.map(el => (
                  <Tag
                    className={'tag-selected'}
                    color={'blue'}
                    style={{ marginTop: '10px' }}
                    key={el.id}
                    closable
                    onClose={() => selectPeopleStore.handleRemoveSelect(el)}>
                    <AvatarHasName
                      imgId={el.image_id}
                      size={22}
                      name={el.full_name}
                      icon={
                        (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                          <BankOutlined />
                        )) ||
                        (el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                          <TeamOutlined />
                        ))
                      }
                    />
                  </Tag>
                ))}
              </SelectList>
            </Col>
          </Row>
          <Form.Item
            style={{
              margin: 0,
              width: '100%',
              marginTop: '15px',
            }}>
            <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
              <Button
                danger
                icon={<CloseOutlined />}
                style={{ marginLeft: '10px' }}
                onClick={handleCancel}>
                Hủy bỏ
              </Button>
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                marginTop: '-30px',
              }}>
              <Button
                icon={<EditOutlined />}
                type="primary"
                htmlType="submit"
                style={{ marginLeft: '10px' }}
                disabled={isSubmitting}>
                Cập nhật
              </Button>
            </div>
          </Form.Item>
        </Form>
      </Modal>
      <SelectPeoplePopup
        onlyOneUser={
          selectPeopleStore.assigneePopupType === ASSIGNEE_TYPE.LEADER
        }
        handleCancelSelectUser={handleCancelSelectUserDepartment}
        handleSubmitSelectUser={() =>
          setIsVisibleSelectUserDepartmentPopup(false)
        }
        isVisibleSelectPeoplePopup={isVisibleSelectUserDepartmentPopup}
      />
      <SelectGroupPopup
        isVisibleSelectGroupPopup={isVisibleSelectGroupPopup}
        handleCancelSelectGroup={handleCancelSelectGroup}
        handleSubmitSelectGroup={() => setIsVisibleSelectGroupPopup(false)}
      />
    </>
  )
}

FeedbackBoardUpdate.propTypes = {}

export default inject(
  'loadingAnimationStore',
  'selectPeopleStore',
  'fileStore',
  'FeedbackProcedureStore',
  'departmentStore',
  'userGroupStore',
  'authenticationStore',
  'departmentStore'
)(observer(FeedbackBoardUpdate))
